export const ORGANIZATION_ENDPOINTS = {
  me: '/orgs/me',
  users: '/org_users',
  spaces: '/org_spaces',
  SSOSettings: '/sso_settings/me',
  invitations: '/org_invitations',
  fieldTypes: '/org_field_types',
  extension: '/org_apps/:extensionId',
  extensions: '/org_apps',
  extensionImageUpload: '/org_apps/upload_image',
  traffic: '/orgs/:orgId/statistics/all_traffic',
  users_reset_password: '/orgs/bulk_reset_password',
}

export const orgStatus = {
  active: 'active',
  disabled: 'disabled',
  deactivated: 'deactivated',
} as const
